export default "__VITE_ASSET__Ppm5vfl0__"